export default __webpack_public_path__ + "static/media/NextLogo.425ae503.png";